var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "image-uploader" } },
    [
      _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
        _c("strong", [_vm._v("Please note:")]),
        _vm._v(
          " the image upload is used for visualising your image in your frame ONLY. We do not print and fit any images into your frame that you upload here."
        ),
      ]),
      _c(
        "b-overlay",
        { attrs: { show: _vm.processing } },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Choose file to visualise in your frame:" } },
            [
              _c("b-form-file", {
                attrs: {
                  state: Boolean(_vm.image),
                  accept: "image/jpeg, image/png, image/gif",
                  placeholder: "Choose a file or drop it here...",
                  "drop-placeholder": "Drop file here...",
                },
                on: { input: _vm.onImageChange },
                model: {
                  value: _vm.image,
                  callback: function ($$v) {
                    _vm.image = $$v
                  },
                  expression: "image",
                },
              }),
            ],
            1
          ),
          _vm.src
            ? _c("vue-cropper", {
                ref: "cropper",
                staticClass: "crop-box",
                attrs: { "aspect-ratio": _vm.aspectRatio, src: _vm.src },
              })
            : _vm._e(),
          _c("b-alert", { attrs: { show: _vm.error, variant: "danger" } }, [
            _vm._v(_vm._s(_vm.error)),
          ]),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "text-right text-md-left", attrs: { md: "4" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-1 mb-md-0",
                      attrs: { disabled: !Boolean(_vm.image), variant: "info" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("rotate")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-1" }, [
                        _vm._v("rotate_right"),
                      ]),
                      _vm._v("Rotate Crop Box"),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { md: "8" } },
                [
                  Boolean(_vm.image)
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mt-1 mb-md-0",
                          attrs: { variant: "danger" },
                          on: { click: _vm.removeImage },
                        },
                        [
                          _c("span", { staticClass: "material-icons mr-1" }, [
                            _vm._v("delete"),
                          ]),
                          _vm._v("Remove Image"),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-1 ml-2",
                      attrs: {
                        variant: "success",
                        disabled: !Boolean(_vm.image),
                      },
                      on: { click: _vm.cropImage },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-1" }, [
                        _vm._v("file_upload"),
                      ]),
                      _vm._v("Crop & Upload Image"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "text-right mt-3" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }